import { Grid } from "@mui/material";
import React from "react";

import { OrderItemImage } from "../../../../../constants";
import { IDisplayLineItemsRow } from "../../../types";
import { sortAndFilterLineItemsForDisplay } from "../../../utils";

export const DisplayLineItemsRow = ({ purchaseState, skdIdx, hideAddons }: IDisplayLineItemsRow) => {
  const sortedAndFilteredLineItems = sortAndFilterLineItemsForDisplay(purchaseState, skdIdx, hideAddons);

  return (
    <Grid
      container
      spacing="10px"
      direction="row"
      alignItems="center"
      justifyContent="start"
      data-testid="line-item-images-row"
    >
      {sortedAndFilteredLineItems.map(item => (
        <Grid item key={item.id}>
          <OrderItemImage
            data-testid="line-item-image"
            purchasableVariant={item.vnt}
            quantity={item.quantity}
            size={"small"}
          />
        </Grid>
      ))}
    </Grid>
  );
};
